import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Col, Text as TextDs } from '@leroy-merlin-br/backyard-react-ui'

const moduleContentStyles = () => css`
  label: module__content;

  display: flex;
  align-items: center;
  justify-contents: center;
  width: 100%;

`
export const ModuleContent = styled('div')(moduleContentStyles)

const moduleAvatarStyles = ({ theme }) => css`
  label: module__avatar;

  align-items: center;
  background: ${theme.colors.n400};
  border-radius: ${theme.borderRadius.circle};
  color: ${theme.colors.n700};
  display: flex;
  font-size: ${theme.typography.headings.exa.fontSize};
  justify-content: center;
  text-align: center;
  text-transform: uppercase;
  margin-right: ${theme.spacings.giga};
  height: 75px;
  width: 75px;
`

export const ModuleAvatar = styled('span')(moduleAvatarStyles)

const moduleWrapperStyles = () => css`
  label: module__wrapper;

  align-items: center;
  display: flex;
`

export const ModuleWrapper = styled('div')(moduleWrapperStyles)

const dividerStyles = ({ theme }) => css`
  label: divider;

  border-right: 1px solid ${theme.colors.n200};
  margin-right: ${theme.spacings.mega};
`

export const Divider = styled(Col)(dividerStyles)

const textWrapperStyles = () => css`
  label: text__wrapper;

  display: block;

`

export const TextWrapper = styled('div')(textWrapperStyles)

const textStyles = ({
  colorSecondary,
  theme
}) => css`
  label: text;

  color: ${colorSecondary ? theme.colors.p500 : theme.colors.n500};

`

export const Text = styled(TextDs)(textStyles)

const statusStyles = ({ theme }) => css`
  label: status;

  color: ${theme.colors.p500};

  &::before {
    background: ${theme.colors.p500};
    border-radius: ${theme.borderRadius.circle};
    content: '';
    display: inline-block;
    margin-right: ${theme.spacings.bit};
    height: ${theme.spacings.byte};
    width: ${theme.spacings.byte};
  }
`

export const Status = styled(Text)(statusStyles)

const buttonIconStyles = ({ theme }) => css`
  label: button__icon;

  display: none;

  ${theme.media.mega} {
    color: ${theme.colors.p500};
    font-size: ${theme.typography.text.giga.fontSize};
    margin-left: auto;
    cursor: pointer;
    outline: 0;
    display: block;
  }
`

export const ButtonIcon = styled('div')(buttonIconStyles)
